import styles from './ProgressBar.module.scss';
import React from 'react';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { useParams, useSearchParams } from 'react-router-dom';
import { nbItemsPerPage } from '../../configs';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../constants/searchParamKeys';
import { useDynamicConfigs } from '../../hooks/useDynamicConfigs';
export const ProgressBar = () => {
    const { nbHits } = useAlgoliaDataContext();
    const { collection } = useDynamicConfigs();
    const { handle } = useParams();
    const [searchParams] = useSearchParams();
    const hitsPerPage = (collection?.capsuleItems !== undefined && collection.capsuleItems.length > 1) ||
        handle === 'photo-prints'
        ? nbItemsPerPage + 1
        : nbItemsPerPage;
    if (nbHits < 1)
        return null;
    const page = +(searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1);
    const viewedItems = Math.min(hitsPerPage * page, nbHits);
    return (React.createElement("div", { className: `text:center ${styles.container}` },
        React.createElement("p", { className: `m:0 ${styles.text}` },
            "You've viewed ",
            viewedItems,
            " of ",
            nbHits,
            " wall art prints"),
        React.createElement("div", { className: styles.bar, style: { '--slider-width': `${viewedItems / nbHits * 100}%` } })));
};
